import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import RecurringDate from './RecurringDate'
import {
    MeetingSearchFiltersDateTypeEnum,
    type MeetingRecurringDateData,
} from '@/Shared/AutoGenerated/Main'

export default class MeetingRecurringDate {
    constructor(
        public readonly uniqueCode: string,
        public readonly recurringMeetingOrder: number,
        public readonly recurringDate: RecurringDate,
    ) {
        ensureNoUndefinedProperties(this)
    }

    getLocalizedDescription(): string {
        return this.recurringDate.getLocalizedDescription()
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(
        entityData: MeetingRecurringDateData,
    ): MeetingRecurringDate {
        return new MeetingRecurringDate(
            entityData.uniqueCode,
            entityData.recurringMeetingOrder,
            RecurringDate.hydrateSingle(entityData.recurringDate),
        )
    }

    static hydrateMultiple(
        entitiesData: MeetingRecurringDateData[],
    ): MeetingRecurringDate[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
